module.exports = __webpack_public_path__ + "img/horizontal_4_2_6000.b7bd86a8.png";